export default "__VITE_ASSET__f0b5c1c9__"